export const UPGRADED_USER_EVENT = 'userUpgraded';

export interface UpgradedUserEventData {
  customerOldType: number | null;
  customerNewType: number | null;
  event: typeof UPGRADED_USER_EVENT;
  upgradedUserId: number;
}
